import axios from '../../axios';
// 材料退货单列表
export const getStkOutMaterialReturnPage = data => {
  return axios({
    url: '/api/sys/stk/getStkOutMaterialReturnPage',
    method: 'post',
    data
  })
};
// 材料退货总合计
export const getStkOutMaterialReturnSum = data => {
  return axios({
    url: '/api/sys/stk/getStkOutMaterialReturnSum',
    method: 'post',
    data
  })
};
// 材料退货单列表保存
export const saveStkOutMaterialReturn = data => {
  return axios({
    url: '/api/sys/stk/saveStkOutMaterialReturn',
    method: 'post',
    data
  })
};
// 材料退货单列表修改
export const updateStkOutMaterialReturn = data => {
  return axios({
    url: '/api/sys/stk/updateStkOutMaterialReturn',
    method: 'post',
    data
  })
};
// 材料退货单列表删除
export const deleteStkOutMaterialReturns = data => {
  return axios({
    url: '/api/sys/stk/deleteStkOutMaterialReturns',
    method: 'post',
    data
  })
};
// 材料退货单列表审核反审
export const auditStkOutMaterialReturns = data => {
  return axios({
    url: '/api/sys/stk/auditStkOutMaterialReturns',
    method: 'post',
    data
  })
};
// 材料退货单列表作废
export const cancelStkOutMaterialReturns = data => {
  return axios({
    url: '/api/sys/stk/cancelStkOutMaterialReturns',
    method: 'post',
    data
  })
};
// 材料退货单明细列表
export const getStkOutMaterialReturnEntryPage = data => {
  return axios({
    url: '/api/sys/stk/getStkOutMaterialReturnEntryPage',
    method: 'post',
    data
  })
};
// 材料退货单明细列表删除
export const deleteStkOutMaterialReturnEntrys = data => {
  return axios({
    url: '/api/sys/stk/deleteStkOutMaterialReturnEntrys',
    method: 'post',
    data
  })
};


// WEBPACK FOOTER //
// ./src/api/moudules/stk/MaterialReturnNote.js